import { Type } from 'class-transformer';

export class BoardApprovalEditorParameterDto {
    isClosed: boolean;
    communityId: number;
    processId: string; // required
    boardMemberUserId: string;

    @Type(() => Date)
    addedOn: Date;
    clearCache = false;

    getQueryString(): string {
        let url = `?clearCache=${this.clearCache}&processId=${this.processId}&isClosed=${
            this.isClosed
        }&addedOn=${this.addedOn.toJSON()}`;

        if (this.communityId) {
            url += `&communityId=${this.communityId}`;
        }
        if (this.boardMemberUserId) {
            url += `&boardMemberUserId=${this.boardMemberUserId}`;
        }

        return url;
    }
}
